import template from './viewInvoicesModal.html';
import controller from './viewInvoicesModal.controller';

let ViewInvoicesModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'lg',
  windowClass: "hmodal-info animated zoomIn"
};

// Export template and controller separately for use with $uibModal.open()
ViewInvoicesModalComponent.template = template;
ViewInvoicesModalComponent.controller = controller;

export default ViewInvoicesModalComponent;




// WEBPACK FOOTER //
// ./client/common/modals/viewInvoicesModal/viewInvoicesModal.component.js